import { useState, useEffect, forwardRef } from "react";
import HighChart from "../HighChart";
import ChartHeader from "../ChartHeader/ChartHeader";
import styles from './ChartGrid.module.css';
import { useChartGridContext } from '../../contexts/ChartGridContext';

const ChartGrid = forwardRef(({ chartData, retakeQuestionRef, peersRef }, ref) => {

    const { showModalSurveyQuestion } = useChartGridContext();

    const [dataLoaded, setDataLoaded] = useState(false);

    useEffect(() => {

        let loaded = false;
        if (chartData !== undefined) {
            if (chartData.length > 0) {
                loaded = true;
            }
        }

        setDataLoaded(loaded);

        let favs = [];
        let peersOnly = [];
        for (let question of chartData) {
            if (question.favorite) {
                favs.push(question.questionId);
            }
            if (question.peersOnly) {
                peersOnly.push(question.questionId);
            }

            // Previously, we withheld the data by blurring the chart if the user hasn't answered the question yet
            // As of 6/7/2024, we're only witholding the data if the user hasn't yet answered AND if (question.surveyQuestionId % 4) === 0)
            // As a result, only about 25% of the unanswered charts are withheld

            let dataWithheld = ((question.answered === false) && ((question.surveyQuestionId % 4) < 3));
            question.dataWithheld = dataWithheld;

        }


    }, [chartData])

    if (!dataLoaded) {
        return (
            null
        )
    } else {
        return (
            <div className={styles.gridContainer}>
                <div className={styles.grid}>
                    {
                        chartData.map((question, i) => {
                            return (
                                <div key={i} className={styles.chartContainer}>
                                    <ChartHeader question={question.question} answered={question.answered} questionId={question.questionId} surveyQuestionId={question.surveyQuestionId} surveyId={question.surveyId} chartType={question.chartType} peersOnly={question.peersOnly} {...(i === 0 ? { retakeQuestionRef: retakeQuestionRef, peersRef: peersRef } : {})}/>
                                    <HighChart chartData={question} />
                                    {
                                        (question.dataWithheld) && <button className={styles.unanswered} onClick={() => showModalSurveyQuestion(question.surveyQuestionId)}>Enter your response to see results</button>
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
});

export default ChartGrid;